const projects = [
  {
    id: 1,
    title: "The Graham",
    description: "Experience comfort and style with our modern luxury apartments.",
    details:
      "Our luxury apartments located at Tse Addo are designed with modern finishes, spacious living areas, and breathtaking views. Perfect for families and professionals who value comfort and elegance.",
    images: [
      "/images/graham1.jpg",
      "/images/graham2.jpg",
      "/images/graham3.jpg",
      "/images/graham4.jpg",
      "/images/graham5.jpg",
      "/images/graham6.jpg",
      "/images/grahaminterior1.jpg",
      "/images/grahaminterior2.jpg",
      "/images/grahaminterior3.jpg",
      "/images/grahaminterior4.jpg",
      "/images/grahaminterior5.jpg",
      "/images/grahaminterior6.jpg",
      "/images/grahaminterior7.jpg",
      "/images/grahaminterior8.jpg",
      "/images/grahaminterior9.jpg",
      "/images/grahaminterior10.jpg",
      "/images/grahaminterior11.jpg",
      "/images/grahaminterior12.jpg",
      "/images/grahaminterior13.jpg",
      "/images/grahaminterior14.jpg",
    ],
  },
  {
    id: 2,
    title: "Smart Homes For Sale",
    description: "Beautiful smart homes designed with elegance and innovation.",
    details:
      "These smart homes combine technology and luxury living. Featuring smart home automation, private pools, and green surroundings, they provide both comfort and efficiency.",
    images: [
      "/images/solosec1.jpg",
      "/images/solo2.jpg",
      "/images/solo3.jpg",
      "/images/solo4.jpg",
      "/images/solo5.jpg",
      "/images/solo6.jpg",
      "/images/solo7.jpg",
      "/images/solo8.jpg",
      "/images/solo9.jpg",
      "/images/solo10.jpg",
      "/images/solo11.jpg",
      "/images/solo12.jpg",
      "/images/solo13.jpg",
      "/images/solo14.jpg",
      "/images/solo15.jpg",
      "/images/solo16.jpg",
      "/images/solo17.jpg",
      "/images/solo18.jpg",
      "/images/solo19.jpg",
      "/images/solo20.jpg",
      "/images/solo21.jpg",
    ],
  },
  {
    id: 3,
    title: "Office Complex",
    description:
      "State-of-the-art office spaces built for productivity and growth.",
    details:
      "Our office complexes are strategically located with modern facilities, conference rooms, and co-working areas to foster innovation and teamwork.",
    images: [
      "/images/project3.jpg",
      "/images/project3-1.jpg",
      "/images/project3-2.jpg",
    ],
  },
  {
    id: 4,
    title: "Homes For Rent",
    description:
      "Premium home located at Burma Hills (Tse Addo), perfect for families and professionals.",
    details:
      "Premium home located at Burma Hills (Tse Addo), perfect for families and professionals. This spacious property offers modern amenities, a fitted kitchen, and a serene environment for comfortable living.",
    video: "/videos/compred.mp4",
    images: ["/images/redsolonetrent.png", "/images/A.png", "/images/B.png", "/images/C.png", "/images/D.png", "/images/E.png", "/images/F.png", "/images/G.png", "/images/H.png"], 
    features: [
      "3 bedrooms",
      "Fitted kitchen",
      "Maids / storage room",
      "Free water supply",
      "Standby generator",
      "24/7 security service",
      "Electric fencing",
      "CCTV surveillance",
      "Ample parking space",
      "Spacious living and dining areas",
      "Modern bathroom fittings",
      "Balcony with scenic views",
    ],
    contact: {
      phone: "+233 24 123 4567",
      email: "info@homesforrent.com",
      address: "Burma Hills, Tse Addo, Accra, Ghana",
    },
  },
    {
    id: 5,
    title: "4 Bedrooms For Sale",
    description:
      "State-of-the-art homes built for families and professionals.",
    details:
      "State-of-the-art homes built for families and professionals. This property is located at Tse Addo and offers modern amenities, spacious living areas, and a peaceful environment.",
    images: [
      "/images/tse1.jpeg",
      "/images/tse2.jpeg",
      "/images/tse3.jpeg",
      "/images/tse4.jpeg",
    ],
        contact: {
      phone: "+233 24 123 4567",
      email: "info@homesforrent.com",
      address: "Tse Addo, Accra, Ghana",
    },
  },
    {
    id: 6,
    title: "5 Bedrooms For Sale",
    description:
      "Luxurious 5-bedroom homes designed for spacious family living.",
    details:
      "Luxurious 5-bedroom homes located in a prime area, featuring modern designs, spacious interiors, and top-notch amenities for comfortable family living.",
    images: [
      "/images/un1.png",
      "/images/un2.png",
      "/images/un3.png",
    ],
        contact: {
      phone: "+233 24 123 4567",
      email: "info@homesforrent.com",
      address: "Tse Addo, Accra, Ghana",
    },
  },
];

export default projects;
